





import Vue from 'vue';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { store } from '../../store/edit/index';

export default Vue.extend({
	name: 'ZakazkaVozidloSelect',
	components: { VozidloSelect: Vozidlo.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_VOZIDLO_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.VOZIDLO_CHANGE}`,
			};
		},
		vozidloFilter(): object {
			return {
				ZakaznikId: this.ZakaznikId,
				Zakazka: !!(this.ZakaznikIdText && this.ZakaznikId),
				Spz: this.VozidloRzv,
				VozidloId: this.VozidloId,
				WorkshopId: this.ProvozovnaId ? this.ProvozovnaId : this.loggedUser.PracovnikProvSelect,
			};
		},
	},
});
